import { render, staticRenderFns } from "./editTask.vue?vue&type=template&id=6e64b5e0&"
import script from "./editTask.vue?vue&type=script&lang=js&"
export * from "./editTask.vue?vue&type=script&lang=js&"
import style0 from "./editTask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editTask.vue"
export default component.exports